import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import OrderDetailsFooter from "./orderdetails/OrderDetailsFooter";
import { useOrderDetails } from "../contexts/orderDetails";
import SectionOrderDetails from "./orderdetails/SectionOrderDetails";
import SectionOrderTimeline from "./orderdetails/SectionOrderTimeline";
import { useAuth } from "../contexts/auth";
import FallbackComponent from "./fallbackRenders/FallbackComponent";
import { ErrorBoundary } from "react-error-boundary";
import ModalAddPaperSize from "./orderdetails/dataModals/ModalAddPaperSize";


export default function OrderDetailPage() {
  const { orderId } = useParams();
  const [{ activeUser }] = useAuth();
  const [{ orderDetails }] = useOrderDetails();
  const navigate = useNavigate();

  const [labelPropToEdit, setLabelPropToEdit] = useState(null);

  if (!orderDetails) {
    return (
      <div className=" h-full p-4">
        <div className=" grid h-full grid-cols-12 grid-rows-7 grid-flow-row gap-3">
          <div className="loading-shimmer col-span-12"></div>
          <div className="loading-shimmer col-span-4 row-span-5"></div>
          <div className="loading-shimmer col-span-8 row-span-5"></div>
          <div className="loading-shimmer col-span-12"></div>
        </div>
      </div>
    );
  }

  return (
    <div key={orderId} className="p-4 h-full overflow-auto">
      <div className="flex justify-between items-center bg-gray-200 p-3 rounded-md">
        <button
          onClick={() => {
            navigate(-1);
          }}
        >
          <span className="bg-orange text-white p-2 rounded-md">Back</span>
        </button>
        <p className="text-2xl text-navy-blue uppercase">
          {orderDetails.party_name}
        </p>

        <p className="text-2xl text-navy-blue">
          Order No: {orderDetails.order_no}
        </p>
      </div>

      <div className="grid grid-cols-12 gap-3 mt-4">
        <ErrorBoundary fallbackRender={FallbackComponent}>
          <SectionOrderTimeline />
        </ErrorBoundary>

        <ErrorBoundary fallbackRender={FallbackComponent}>
          <ModalAddPaperSize />
          <SectionOrderDetails
            setLabelPropToEdit={setLabelPropToEdit}
            labelPropToEdit={labelPropToEdit}
          />
        </ErrorBoundary>

        <ErrorBoundary fallbackRender={FallbackComponent}>
          {activeUser?.user_permission <= 2 && (
            <OrderDetailsFooter />
          )}
        </ErrorBoundary>
      </div>
    </div>
  );
}
